// Keep the reporting and moderation implementation available while its public UI
// is paused. Re-enable the entry points together when the feature is revisited.
export const COMMENT_REPORTING_UI_ENABLED = false;
